import { render } from "./VideoBannerTwo.vue?vue&type=template&id=2408fffa"
import script from "./VideoBannerTwo.vue?vue&type=script&lang=js"
export * from "./VideoBannerTwo.vue?vue&type=script&lang=js"

import "./VideoBannerTwo.vue?vue&type=style&index=0&id=2408fffa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__